export default __webpack_public_path__ + "static/media/lumbar.8cca6f72.webp";